import { useSyncExternalStore, useCallback } from 'react';
import type * as Y from 'yjs';
import { PROJECTED_LAYOUT_MAP, type ProjectedLayoutMode } from '../core/canvas/projectedLayout';

export function useProjectedLayoutMode(doc: Y.Doc | null | undefined): ProjectedLayoutMode | undefined {
  const subscribe = useCallback((notify: () => void) => {
    if (!doc) return () => {};
    const map = doc.getMap(PROJECTED_LAYOUT_MAP);
    map.observe(notify);
    return () => map.unobserve(notify);
  }, [doc]);
  const snapshot = useCallback(() => {
    const mode = doc?.getMap(PROJECTED_LAYOUT_MAP).get('mode');
    return mode === 'automatic' || mode === 'custom' ? mode : undefined;
  }, [doc]);
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
